import urlPrefix from "./apiPrefix";

export const putBaseCatalogueItemUpdate = () => `${urlPrefix.value}/tax-web-control/api/base-catalogue/item/update`;
export const postBaseCatalogueItemCreate = () => `${urlPrefix.value}/tax-web-control/api/base-catalogue/item/create`;
export const getBaseCatalogueItemUpdated = () => `${urlPrefix.value}/tax-web-control/api/base-catalogue/updated`;
export const getBaseCatalogueItem = (id: number) => `${urlPrefix.value}/tax-web-control/api/base-catalogue/item/${id}`;
export const getBaseCatalogueItemList = () => `${urlPrefix.value}/tax-web-control/api/base-catalogue/item/list`;
export const getBaseCatalogueItemListActivate = () => `${urlPrefix.value}/tax-web-control/api/base-catalogue/item/listActive`;
export const deleteBaseCatalogueItem = (id: number) => `${urlPrefix.value}/tax-web-control/api/base-catalogue/item/delete/${id}`;
